module.exports = __webpack_public_path__ + "static/media/cge-logo.007f5c12.png";